import { get } from "lodash-es";
import { useAssetContext } from "../../../../context/assetContext";
import { Asset } from "../../../../models/Asset";
import { getAssets } from "../../../../repositorie/MESF-frontend-Repositorie";
import { useConfigurationAssetContext } from "../context/ConfigurationAssetContext";
import { TransformAssetModelData } from "./TransformAssetModelData";

type Props = {
	setSearchError: (err: string) => void;
	setAllAssetLoading: (loader: boolean) => void;
};

export const useSearchAssets = ({
	setSearchError,
	setAllAssetLoading,
}: Props) => {
	const {
		actions: { setAllAssets, setAreasList },
	} = useAssetContext();

	const {
		actions: { setAllAssetNodes },
	} = useConfigurationAssetContext();

	const searchAssets = () => {
		getAssets().then((res: any) => {
			if (res.ok) {
				let mydataSource: any[] = [];

				const rows = get(res, "data.tables[0].rows", []);
				const areas: Asset[] = rows.filter(
					(asset: Asset) => asset.CanBeDefaultAsset,
				);
				setAllAssets(rows);
				setAreasList(areas);
				rows.forEach((row: Asset) => {
					const code = TransformAssetModelData(row);
					mydataSource = [...mydataSource, code];
				});
				setAllAssetNodes(mydataSource);
				setAllAssetLoading(false);
			} else setSearchError(res.message);
		});
	};
	return { searchAssets };
};
